<template>
    <div>
        <label ref="field" :class="size">
            <span v-if="label">
                {{ label }}
                <span v-if="required" class="label-required">*</span>
                <i class="files-types">
                    {{ helpText }}
                </i>
            </span>
			
            <div class="input">
                <img v-if="target !== 'Nenhum arquivo escolhido' && setImg(target)" :src="setImg(target)" alt="imagem de arquivo xlsx/xls/docx/doc/pdf" width="40px"/> 
                <img v-show="target !== 'Nenhum arquivo escolhido' && target.match(/.png|.jpeg|.jpg/)" ref="imgUpload"  alt="imagem de arquivo pnj/jpeg/jpg" width="40px"/>

                <div v-if="refer" class="input-file-select">
                    <ui-button design="primary sm" @click="$refs[refer].click()">Selecionar</ui-button>
                    {{target}}        
                </div>  

                <input
                    :id="id"
                    :ref="refer"
                    :class="refer ? 'input-file' : ''"
                    type="file"
                    :name="name"
                    :value="value"
                    :accept="accept"
                    @input="onChange($event)"
                    @focus="clearError" 
                />

                <section v-if="setTarget[id] && setTarget[id] == 'loading'">
                    <ui-load-indicator :h="30" :stroke="6" bg-color="#e7e9f4" color="#69D296" />
                    <span  class="success-icon">
                        <i class="fal fa-check-circle"/>
                    </span>
                </section>

                <section v-if="btnRemove && setTarget[id] && setTarget[id] == 'loaded'">
                    <ui-button  design="danger sm" @click="remove">Remover</ui-button>
                </section>
				
            </div>
        </label>
    </div>
</template>

<script>
	import { mask } from "vue-the-mask";

	import { uiLoadIndicator} from '@/components/ui'

	import { uiButton } from '@/components/ui/buttons'

	import helpers from '@/mixins/helpers'

	export default {
		name: "ui-upload-files",

		components: {uiButton, uiLoadIndicator},

		directives: { mask },

		mixins: [helpers],

		props: {
			/**
			 * Utilize para alterar o texto do label do input
			 */
			label: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para aplicar a qual input o label é referido
			 */
			refer: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para aplicar id do input
			 */
			id: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para aplicar o name no input
			 */
			name: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para acessar o value do input
			 */
			value: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para alterar o tamanho do input
			 */
			size: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para alterar o texto de help do input
			 */
			helpText: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para alterar o tipo de arquivo a ser buscado
			 */
			accept: {
				type: String,
				required: false,
				default: '.doc,.docx'
			},
			btnRemove: {
				type: Boolean,
				default: false
			},
			fieldSlug: {
				type: String,
				required: false,
				default: ''
			},
			setDocs: {
				type: [Object, String, Array],
				required: false,
				default: () => {}
			},
			/**
				* define o campo como required em html5 e aplica o operador '*' na label
				*/
			required: {
				type: Boolean,
				required: false,
				default: false
			},


		},

		data() {
			return {
				target: 'Nenhum arquivo escolhido',
				setTarget: {
					[this.id]:null
				}
			}
		}, 

		mounted() {
			
			this.$root.$on('confirm-delete-success', (id) => {
				if(this.$refs[this.refer].id == id) {
					this.target = 'Nenhum arquivo escolhido'
					this.setTarget[this.id] = null
					this.addImg()
				}
			})

			this.$root.$on('cancel-load-dynamic', (data) => {
				if(data.data) {
					for(const repeater in data.data) {
						this.setTarget[repeater] = 'loaded'
					}
				}
			}) 

			this.$root.$on('cancel-load-doc', (response) => {
				this.setTarget[response] = 'loaded'
			})

			this.$root.$on('clean-file-doc', () => {
				this.setTarget[this.id] = null
				this.target = 'Nenhum arquivo escolhido'
			})
		},
		

		beforeDestroy() {
			this.$root.$off('confirm-delete-success')
			this.$root.$off('cancel-load-doc')
			this.$root.$off('clean-file-doc')
		},

		methods: {
			onChange(event) {
				this.setTarget[this.id] = 'loading'
				this.target = event.target.files[0].name
				this.addImg(event)
				this.$emit("input",  event.target.value)
				this.$emit('change', {event: event, slug: this.fieldSlug, id: this.id})
			},

			clearError() {
				this.$refs.field.classList.remove("error");
			},

			remove() {
				this.$emit('remove')
			},

			addImg(event, base64) {
				let preview = this.$refs.imgUpload
				let src = ''
				if(event) {
					src = base64 ? event : URL.createObjectURL(event.target.files[0])
				} 
				preview.src = src
			},
			
			setImg(target) {
				if (target.match(/.pdf/)) return require('@/assets/imgs/icon-pdf.png')
				if (target.match(/.docx|.doc/)) return require('@/assets/imgs/icon-docx.png')
				if (target.match(/.xls|.xlsx/)) return require('@/assets/imgs/icon-xls.png')
			}
			
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
